// This file is automatically generated from ingestAssets.mjs
import { IllustrationTokens } from '../../../components/Illustration/Illustration.types';
const illustrationTokens: IllustrationTokens = {
	'sds-assets/base/illustration/square/arrowClockwise': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/arrowClockwise.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/arrowsStraightVertical': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/arrowsStraightVertical.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/arrowsThree': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/arrowsThree.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/arrowVertical': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/arrowVertical.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/bell': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/bell.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/blocks': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/blocks.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/calendar': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/calendar.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/chartBar': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/chartBar.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/chartPieSegment': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/chartPieSegment.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/chartPieSegmentUSD': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/chartPieSegmentUSD.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/circleCheck': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/circleCheck.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/circleLightningBolt': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/circleLightningBolt.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/circlesThree': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/circlesThree.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/circleUSDPartialFill': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/circleUSDPartialFill.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/circleX': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/circleX.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/compass': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/compass.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/crypto': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/crypto.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/debitCard': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/debitCard.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/debitCardCheckMark': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/debitCardCheckMark.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/diamond': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/diamond.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/flag': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/flag.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/flagPlusVertical': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/flagPlusVertical.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/gift': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/gift.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/hexagonVertical': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/hexagonVertical.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/hourglass': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/hourglass.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/house': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/house.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/houseQuestion': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/houseQuestion.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/hyperlink': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/hyperlink.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/locationPin': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/locationPin.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/lockClosed': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/lockClosed.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/magnifyingGlass': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/magnifyingGlass.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/moneyBillQuestion': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/moneyBillQuestion.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/moneyBillSimple': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/moneyBillSimple.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/moneyBillSplit': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/moneyBillSplit.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/moneyBillUSDSegment': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/moneyBillUSDSegment.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/mountainPeak': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/mountainPeak.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/mountainsThree': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/mountainsThree.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/newspaper': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/newspaper.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/progressCheck': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/progressCheck.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/receiptUSD': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/receiptUSD.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/safe': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/safe.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/shield': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/shield.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/shieldUSD': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/shieldUSD.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/squareFourUSD': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/squareFourUSD.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/sunrise': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/sunrise.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/tagUSD': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/tagUSD.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/trophy': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/trophy.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/truck': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/truck.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/userIdentity': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/userIdentity.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/userIdentityPhoto': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/userIdentityPhoto.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/userQuestion': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/userQuestion.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/usersChild': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/usersChild.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/usersTwo': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/usersTwo.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/obCarouselLogo': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/obCarouselLogo.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/obCarouselLongterm': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/obCarouselLongterm.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/obCarouseSmart': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/obCarouseSmart.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/obCarouselAuto': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/obCarouselAuto.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/obCarouselStocks': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/obCarouselStocks.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/lightbulb': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/lightbulb.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/piggyBank': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/piggyBank.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/stockBackGift': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/stockBackGift.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/checkExample': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/checkExample.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/square/smartPortfolioIllustration': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/square/smartPortfolioIllustration.svg',
		ratio: 'square',
	},
	'sds-assets/base/illustration/extraWide/obCarouselLogo': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/extraWide/obCarouselLogo.svg',
		ratio: 'extraWide',
	},
	'sds-assets/base/illustration/extraWide/obCarouselLongterm': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/extraWide/obCarouselLongterm.svg',
		ratio: 'extraWide',
	},
	'sds-assets/base/illustration/extraWide/obCarouseSmart': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/extraWide/obCarouseSmart.svg',
		ratio: 'extraWide',
	},
	'sds-assets/base/illustration/extraWide/obCarouselAuto': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/extraWide/obCarouselAuto.svg',
		ratio: 'extraWide',
	},
	'sds-assets/base/illustration/extraWide/obCarouselStocks': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/extraWide/obCarouselStocks.svg',
		ratio: 'extraWide',
	},
	'sds-assets/base/illustration/extraWide/goals': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/extraWide/goals.svg',
		ratio: 'extraWide',
	},
	'sds-assets/base/illustration/extraWide/dollarCostAveraging': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/extraWide/dollarCostAveraging.svg',
		ratio: 'extraWide',
	},
	'sds-assets/base/illustration/extraWide/gradientSwoop': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/extraWide/gradientSwoop.svg',
		ratio: 'extraWide',
	},
	'sds-assets/base/illustration/bleed/dollarCostAveraging': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/bleed/dollarCostAveraging.svg',
		ratio: 'bleed',
	},
	'sds-assets/base/illustration/bleed/unfundedSmart': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/bleed/unfundedSmart.svg',
		ratio: 'bleed',
	},
	'sds-assets/base/illustration/bleed/unfundedPersonal': {
		url: 'https://assets.stash.com/sds-assets/base/illustration/bleed/unfundedPersonal.svg',
		ratio: 'bleed',
	},
};
export default illustrationTokens;
